__turbopack_context__.v({
  "articleList": "articleList-module-scss-module__nSourq__articleList",
  "fullContainer": "articleList-module-scss-module__nSourq__fullContainer",
  "halfContainer": "articleList-module-scss-module__nSourq__halfContainer",
  "header": "articleList-module-scss-module__nSourq__header",
  "icon": "articleList-module-scss-module__nSourq__icon",
  "itemLabel": "articleList-module-scss-module__nSourq__itemLabel",
  "left": "articleList-module-scss-module__nSourq__left",
  "leftMaxContainer": "articleList-module-scss-module__nSourq__leftMaxContainer",
  "listItems": "articleList-module-scss-module__nSourq__listItems",
  "right": "articleList-module-scss-module__nSourq__right",
  "rightMaxContainer": "articleList-module-scss-module__nSourq__rightMaxContainer",
  "title": "articleList-module-scss-module__nSourq__title",
});
